// In-app feedback, replacing window.alert(). Toasts don't block the page and
// read in the app's own voice; use them for outcomes ("Bid marked as won") and
// for errors that say what failed and what to do next.
//
//   import { notify } from '@/utils/notify';
//   notify.success('Bid marked as won');
//   notify.error('Couldn’t update the bid. Check your connection and try again.');
//
// useToast() works outside setup() once the plugin is installed (main.js): it
// falls back to the library's global event bus.
import { useToast } from 'vue-toastification';

let toast = null;
function get() {
    if (!toast) toast = useToast();
    return toast;
}

export const notify = {
    success: (message, options) => get().success(message, options),
    error: (message, options) => get().error(message, { timeout: 6000, ...options }),
    warning: (message, options) => get().warning(message, options),
    info: (message, options) => get().info(message, options),
};

export default notify;
